<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="编号" prop="no">
            <el-input v-model.trim="model.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="打印机名称" prop="name">
            <el-input v-model.trim="model.name" placeholder="请输入打印机名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="打印机IP" prop="ip">
            <el-input v-model.trim="model.ip" placeholder="请输入打印机IP"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <el-switch
                v-model="model.status"
                active-text="启用"
                inactive-text="禁用"
                :active-value="0"
                :inactive-value="1"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "PrinterManageEdit",
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          pkid: "",
          no: "",
          name: "",
          ip: "",
          status: 0,
        },
        ruleValidate: {
          name: { required: true, message: "不能为空", trigger: "blur" },
          ip: { required: true, message: "不能为空", trigger: "blur" },
          status: { required: true, message: "不能为空", trigger: "change" },
          note: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        }
      },
      getData(pkid) {
        this.$http.get("basic", `printers/${pkid}`).then((res) => {
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "printers", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "printers", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
